export function roundToNearestHalf(num: number) {
	return Math.round(num * 2) / 2;
}

export function roundToNearest5(num: number) {
	return Math.ceil(num / 5) * 5;
}
